import styles from './Row.module.scss'
import { classNames } from '@/components/shared/classNames'

export interface RowProps extends React.HTMLProps<HTMLDivElement> {
  children?: React.ReactNode
  className?: string
  onClick?: () => void
}

export const Row = ({ children, className, onClick }: RowProps) => {
  return (
    <div className={classNames(styles.row, className)} onClick={onClick}>
      {children}
    </div>
  )
}
